
import React from 'react';

const Differential: React.FC = () => {
  return (
    <section className="py-24 bg-gradient-to-t from-red-600/10 to-transparent">
      <div className="container mx-auto px-6">
        <div className="glass p-12 md:p-20 rounded-[3rem] border-white/10 relative overflow-hidden">
          <div className="absolute -top-24 -right-24 w-64 h-64 bg-red-600/20 blur-[100px] rounded-full" />
          
          <div className="max-w-3xl relative z-10">
            <h2 className="text-4xl md:text-6xl font-black mb-8">Diferencial LQP</h2>
            <div className="space-y-8">
              <div className="flex gap-6">
                <div className="text-4xl">🤝</div>
                <div>
                  <h4 className="text-xl font-bold mb-2">Acompañamiento Humano</h4>
                  <p className="text-gray-400 leading-relaxed">No somos solo código. Pensamos a largo plazo y construimos sistemas que crecen con tu negocio, estando presentes en cada paso.</p>
                </div>
              </div>
              <div className="flex gap-6">
                <div className="text-4xl">⚡</div>
                <div>
                  <h4 className="text-xl font-bold mb-2">Soluciones Reales</h4>
                  <p className="text-gray-400 leading-relaxed">Tecnología que se adapta a vos y no al revés. Resolvemos cuellos de botella reales con herramientas de última generación.</p>
                </div>
              </div>
            </div>
            
            <div className="mt-12 flex flex-col sm:flex-row gap-4">
              <button className="px-10 py-5 bg-red-600 hover:bg-red-700 text-white font-black rounded-2xl transition-all shadow-2xl shadow-red-600/30 transform hover:-translate-y-1">
                INICIAR TRANSFORMACIÓN
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Differential;
